import React, { forwardRef, useState, useEffect, useImperativeHandle } from 'react'
import { StatusCellComponent } from '../../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';
import NoRowOverlay from '../../../../masters/holidayMaster/NoRowOverlay';
import { gridComponents, gridStyles } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { GridRowModes } from '@mui/x-data-grid';
import { ActionsCellComponent } from '../../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getFormattedDate } from 'views/pages/manage/edpOps/constant/batch-search';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { dropdowns, newRow } from './constant';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import ALoader from 'views/pages/manage/common/a-loader';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import { Tooltip } from '@mui/material';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import { regex } from 'views/pages/manage/common/constant';
import moment from 'moment';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../../manage/common/constant'


const ListComponet = ({
    businessAreaDropdown = [],
    rows = [],
    createUpdateHandler,
    loading,
    currentPage,
    totalRecords,
    pageChangeHandler,
    dropdowns,
    // setDropdowns
}, ref) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});


    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);


    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit, fieldToFocus: "financeInstitution" },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let randomId = generateRandomId();
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: randomId,
            };
            startEditing(randomId, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };
    const getTaxCodePercentage= async(taxCodeId)=>{
        const data= await fetchAllPromisedData(`${endpoint?.taxCodeId?.getTaxCodeId}/${taxCodeId}`)
        rowFormHandler(data?.totalTaxValue,'taxCodePercent')
    }


    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const columns = [
        new AGridColDef('srNo', 'Sr. No.', false)
            .setMinWidth(80)
            .setFlex(0.5)
            .editable(false)
            .setValueGetter(params => params?.value),

        new AGridColDef('taxType', 'Tax Type', false)
            .setMinWidth(110)
            .setFlex(0.5)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>

                    <AAutoComplete
                        currentValue={rowForm?.taxType}
                        handleChange={value => {
                            rowFormHandler(value, 'taxType');
                            // setRowForm((prev) => ({ ...prev, 'taxType': value, 'examType': [] }))
                        }}
                        items={dropdowns.taxType}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef('taxCodeType', 'Tax Code Type', false)
            .setMinWidth(140)
            .setFlex(1.4)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>

                    <AAutoComplete
                        currentValue={rowForm?.taxCodeType}
                        handleChange={value => {
                            rowFormHandler(value, 'taxCodeType');
                            // setRowForm((prev) => ({ ...prev, 'taxType': value, 'examType': [] }))
                        }}
                        items={dropdowns.taxCodeType}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef('codeId', 'Code ID', false)
            .setMinWidth(80)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.codeId}
                        handleChange={value => {
                            rowFormHandler(value, 'codeId');
                            getTaxCodePercentage(value?.id)
                            // setRowForm((prev) => ({ ...prev, 'taxType': value, 'examType': [] }))
                        }}
                        items={dropdowns.codeId}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),

        new AGridColDef('taxCodePercent', 'Tax Code %', false)
            .setMinWidth(110)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter(params => params?.value)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AInput
                        type="text"
                        value={rowForm?.taxCodePercent} // Dynamically access value
                        handler={(value) => {
                            rowFormHandler(value, 'taxCodePercent');
                        }}
                        placeholder="Enter"
                        regex={regex?.percentage}
                        disabled={true}
                    // style={inputStyle}
                    // maxLength={col?.maxLength}
                    />
                </div>
            )),
        new AGridColDef("effectiveDate", "Effective Date", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={moment(params?.value).format('DD/MM/YYYY')}>
                    <div className={`ellipsis-text-container`}>{moment(params?.value).format('DD/MM/YYYY')}</div>
                </Tooltip> : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <CustomDatePickerV2
                        //style={{ input: inputStyle }}
                        placeHolder="Select date"
                        value={rowForm?.effectiveDate}
                        handler={(index, date) => {
                            rowFormHandler(date, 'effectiveDate');
                        }}
                        isStartDate={true}
                    // minDate={moment(new Date(), "DD-MM-YYYY").subtract(1, "months")}
                    // maxDate={new moment(new Date())}
                    // disabled={action == 'new' ? false : col.disabled}
                    />
                </div>
            ))
        ,
        new AGridColDef('updatedOn', 'Last Updated On', false)
            .setMinWidth(120)
            .setFlex(1)
            .editable(false)
            .renderCellComponent((params) =>
                params?.value ? (
                    <Tooltip title={`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}>
                        <div className="ellipsis-text-container">
                            {`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            )
        ,
        new AGridColDef('actions', 'Action', false)
            .setMinWidth(110)
            .setFlex(1)
            .editable(true)
            // .pinColumnLast(true)
            .columnAlign('right')
            .renderCellComponent(params =>
                <ActionsCellComponent
                    mode={'view'}
                    handleEditClick={handleEditClick}
                    //handleSaveClick={handleSaveClick}
                    //handleCancelClick={handleCancelClick}
                    icon={true}
                    //cancelIcon={true}
                    //deleteIcon={true}
                    params={params}
                    customEditIcon
                />
            )
            .renderEditCellComponent(params => (
                <ActionsCellComponent
                    mode={'edit'}
                    handleSaveClick={handleSaveClick}
                    //handleCancelClick={handleCancelClick}
                    icon={true}
                    cancelIcon={<CancelIcon
                        className="mx-2 cursor"
                        onClick={() => handleCancelClick(params)}
                    />}
                    //deleteIcon={true}
                    params={params}
                    isSaveDisabled={!(rowForm?.taxType && rowForm?.taxCodeType && rowForm?.codeId && rowForm?.taxCodePercent && rowForm?.effectiveDate)}
                />
            )),

    ]

    return (
        <>
            {loading && <ALoader position='fixed' />}
            <ADataGrid
                removeWrapperContainer
                rowModesModel={rowModesModel}
                rows={rowData || []}
                columns={columns}
                rowId={(row) => (row?.id)}
                rowHeight={50}
                loading={false}
                rowCount={totalRecords}
                nextButtonHandler={pageChangeHandler}
                currentPage={currentPage}
                hidePagination
                components={{
                    ...gridComponents,
                    NoRowsOverlay: () => (
                        <NoRowOverlay message={loading ? "Loading..." : null} />
                    ),
                }}
                sx={gridStyles}
                autoHeight
            // pinLastColumn
            />
        </>
    );
}

export default forwardRef(ListComponet);